// extracted by mini-css-extract-plugin
export var linkText = "_o5-0";